<app-modal [open]="active" [name]="'opt-in'" (close)="closeDialog()">
  <div modal-header>Confirm SMS Opt-In</div>
  <div modal-body>
    <div
      *ngIf="user.phone && user.phone2; else singlePhoneSelection"
      [formGroup]="phoneFormGroup"
    >
      <p>
        You’re about to opt in for SMS notifications. Please choose the
        phone number you’d like to use:
      </p>
      <div>
        <label>
          <input
            type="radio"
            formControlName="selectedPhone"
            [value]="user.phone"
            style="width: auto"
            data-testid="opt-in-phone-primary"
          />
          Primary Phone Number:
          <span style="font-weight: bold">{{ user.phone }}</span>
        </label>
      </div>
      <div>
        <label>
          <input
            type="radio"
            formControlName="selectedPhone"
            [value]="user.phone2"
            style="width: auto"
            data-testid="opt-in-phone-secondary"
          />
          Secondary Phone Number:
          <span style="font-weight: bold">{{ user.phone2 }}</span>
        </label>
      </div>
    </div>
    <ng-template #singlePhoneSelection>
      <p>
        You're about to opt in to receive SMS notifications using the
        phone number you provided:
        <b>{{ user.phone ? user.phone : user.phone2 }}.</b>
      </p>
      <p>Do you want to proceed?</p>
    </ng-template>
    <div class="opt-in-dialog__links">
      <a
        href="https://cretelligent.com/website-terms-of-use/"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="opt-in-terms-link"
        >Terms & Conditions</a
      >
      <a
        href="https://cretelligent.com/privacy-policy/"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="opt-in-privacy-link"
        >Privacy Policy</a
      >
    </div>
  </div>
  <button
    modal-footer
    type="button"
    class="btn btn--primary"
    data-testid="opt-in-confirm"
    (click)="submit()"
    [disabled]="isSubmitting"
  >
    Opt-In
  </button>
  <button
    modal-footer
    type="button"
    class="btn btn--secondary"
    data-testid="opt-in-cancel"
    (click)="closeDialog()"
  >
    Cancel
  </button>
</app-modal>
